import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CookieWarning from 'src/components/CookieWarning';
import 'src/exceptionReporting';
import loadDevTools from 'src/dev-tools/load';
/** TO-DO: React 18 update
 * import { createRoot } from 'react-dom/client';
 */

export function renderDom(
  Component: React.ComponentType,
  container: string,
  props: Record<string, any> = {}
) {
  const rootEl = document.querySelector(container);
  if (!rootEl) {
    return;
  }

  /** TO-DO: React 18 update
   * const root = createRoot(container); // createRoot(container!) if you use TypeScript
   */

  loadDevTools(() => {
    /** TO-DO: React 18 update
     * root.render(
     */
    ReactDOM.render(
      navigator.cookieEnabled ? <Component {...props} /> : <CookieWarning />,
      rootEl
    );
  });
}